/**
 * @format
 */

var SpotModel = require("../models/SpotModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

/**
 * @param {QueueModel} viewModel
 * @param {() => string} userLanguage
 */
function ExpiredTicketsWS(viewModel, userLanguage) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.name = "ExpiredTicketsWS";
  self.spots = ko.observableArray([]);
  self.userLanguage = userLanguage;

  /**
   * Collects the names of any custom properties within
   * the collection of spots. As different consumers
   * may have different custom properties (some may have a
   * different number of properties, in different orders, etc)
   * this ensures that the display will be consistent and label
   * the columns and data accordingly
   *
   * @method customProps
   * @returns {Array}
   */
  self.customProps = ko.computed(function () {
    var spots = self.spots();
    var props = [];

    spots.forEach(function (s) {
      if (s.customProps) {
        s.customProps.forEach(function (p) {
          props.push(p.name);
        });
      }
    });

    return props.unique();
  });

  /**
   * Locates a SpotModel instance by the session id
   *
   * @method getTicketBySessionId
   * @param {String} sSessionId
   * @returns {SpotModel | Null}
   */
  self.getSpotBySessionId = function (sSessionId) {
    return self.spots().filter(function (spot) {
      return spot.sessionId === sSessionId;
    })[0];
  };

  /**
   * Determines if any of the spots have the requested field with values
   *
   * @method hasFieldValues
   * @param {String} val
   * @returns {Boolean}
   */
  self.hasFieldValues = function (val) {
    return (
      self.spots().filter(function (spot) {
        return typeof spot[val] === "function" ? spot[val]() : spot[val];
      }).length > 0
    );
  };

  /**
   * Defines the string to request API services
   *
   * @method serviceURL
   * @returns {String}
   */
  self.serviceURL = ko.computed(
    function () {
      var ids = self.parent.id
        ? [self.parent.id]
        : self.parent.parent
        ? self.parent.parent.selectedQueueIds()
        : [];
      var queryString = "?locale=" + self.userLanguage();

      return ids.length > 0
        ? "/qless/api/v1/employee/queues/" +
            ids.join(",") +
            "/tickets/expired" +
            queryString
        : null;
    },
    self,
    { deferEvaluation: true }
  );

  /**
   * This method iterates over the data returned from the service and
   * converts the individual nodes into LocationModels and then assigns
   * them to this object's locations collection.
   *
   * @method processData
   * @param {XMLString} xmlData XML data returned from the service
   * @returns {LocationsWS} Returns the object as chainable, for best practice
   */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);
    if (json) {
      var spots =
        json.queueSpots && json.queueSpots.spot
          ? Array.makeArray(json.queueSpots.spot)
          : [];

      self.spots(
        spots.map(function (spotData) {
          return new SpotModel(spotData);
        })
      );
    }

    return self;
  };

  /**
   * Returns the object to it's initial state
   *
   * @method reset
   * @returns none
   */
  self.reset = function () {
    self.spots.removeAll();
    AbstractWS.prototype.reset.call(self);
  };

  return self;
}

ExpiredTicketsWS.prototype = AbstractWS.prototype;
ExpiredTicketsWS.prototype.constructor = ExpiredTicketsWS;

module.exports = ExpiredTicketsWS;
